import PropTypes from "prop-types";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "./ContactForm.css";
import "react-toastify/dist/ReactToastify.css";

import Footer from "../../siteComponents/Footer";
import TopBar from "../../siteComponents/Topbar";

import { notifyUser } from "../../utils/notifyUser";

export default function ContactForm({ user }) {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [email, setEmail] = useState("");
    const location = useLocation();

    // Check if this is the public contact form or the dashboard contact form
    const isPublicContactForm = location.pathname === "/contact-us";

    // Determine if this is an authenticated user or anonymous visitor
    const isAuthenticated = !!user?.id;

    const handleSubmit = async (e) => {
        e.preventDefault();

        // For anonymous users, validate email
        if(!isAuthenticated && (!email || !email.includes("@"))) {
            notifyUser(null, "error", "Please enter a valid email address", "toast", null, null, null, null, null, false, false, "top-center");
            return;
        }

        try {
            // Create payload based on authentication status
            const payload = isAuthenticated
                ? {
                      user_id: user.id,
                      title,
                      description,
                  }
                : {
                      email,
                      title,
                      description,
                  };

            const response = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/api/faq/submit-query`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                },
            );

            const data = await response.json();

            if(response.ok) {
                notifyUser(null, "success", data.message, "toast", null, null, null, null, null, false, false, "top-center");
                setTitle("");
                setDescription("");
                setEmail("");
                 // Trigger admin notification email
                try {
                    await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/faq/contact-form-notification`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            email: isAuthenticated ? user.email : email,
                            title,
                            description
                        })
                    });
                } catch (notifyErr) {
                    // Optionally log or toast error, but don't block user
                    console.error("Failed to notify admin:", notifyErr);
                }
            } else {
                notifyUser(null, "error", data.error || "Failed to submit query.", "toast", null, null, null, null, null, false, false, "top-center");
            }
        } catch(error) {
            console.error("Error submitting query:", error);
            notifyUser(null, "error", "An error occurred. Please try again.", "toast", null, null, null, null, null, false, false, "top-center");
        }
    };
    // Create the contact form component
    const contactForm = (
        <div
            style={{
                background: "#fff",
                borderRadius: "16px",
                boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
                padding: "40px 36px 32px 36px",
                maxWidth: 900,
                width: "100%",
                margin: "48px auto",
            }}
        >
            <h2
                className="form-title uppercase"
                style={{
                    textAlign: "center",
                    fontWeight: 700,
                    fontSize: 28,
                    color: "var(--navy)",
                    marginBottom: 32,
                    letterSpacing: 1,
                }}
            >
                Contact Us
            </h2>
            <form onSubmit={handleSubmit}>
                {/* Show email field only for anonymous users */}
                {!isAuthenticated && (
                    <div className="form-group" style={{ marginBottom: 24 }}>
                        <label
                            style={{
                                fontWeight: 600,
                                color: "var(--navy)",
                                marginBottom: 8,
                                display: "block",
                            }}
                        >
                            Your Email
                        </label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            style={{
                                width: "100%",
                                borderRadius: 8,
                                border: "1px solid #bcd0e5",
                                padding: "12px 16px",
                                fontSize: 16,
                                outline: "none",
                                background: "#F5F7FA",
                                transition: "border 0.2s",
                            }}
                            placeholder="Enter your email address"
                        />
                    </div>
                )}
                <div className="form-group" style={{ marginBottom: 24 }}>
                    <label
                        style={{
                            fontWeight: 600,
                            color: "var(--navy)",
                            marginBottom: 8,
                            display: "block",
                        }}
                    >
                        Subject
                    </label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                        style={{
                            width: "100%",
                            borderRadius: 8,
                            border: "1px solid #bcd0e5",
                            padding: "12px 16px",
                            fontSize: 16,
                            outline: "none",
                            background: "#F5F7FA",
                            transition: "border 0.2s",
                        }}
                        placeholder="Enter your subject"
                    />
                </div>
                <div className="form-group" style={{ marginBottom: 32 }}>
                    <label
                        style={{
                            fontWeight: 600,
                            color: "var(--navy)",
                            marginBottom: 8,
                            display: "block",
                        }}
                    >
                        Description
                    </label>
                    <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        required
                        rows="5"
                        style={{
                            width: "100%",
                            borderRadius: 8,
                            border: "1px solid #bcd0e5",
                            padding: "12px 16px",
                            fontSize: 16,
                            outline: "none",
                            background: "#F5F7FA",
                            resize: "vertical",
                            minHeight: 120,
                        }}
                        placeholder="Describe your query in detail"
                    ></textarea>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button
                        type="submit"
                        className="submit-btn"
                        style={{
                            background: "var(--navy)",
                            color: "#fff",
                            border: "none",
                            borderRadius: 8,
                            padding: "12px 36px",
                            fontWeight: 600,
                            fontSize: 18,
                            cursor: "pointer",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                            transition: "background 0.2s",
                        }}
                    >
                        Submit
                    </button>
                </div>{" "}
            </form>
        </div>
    );

    // Return the form wrapped with TopBar and Footer if it's a public view
    return isPublicContactForm ? (
        <>
            <TopBar />
            {contactForm}
            <Footer />
        </>
    ) : (
        // Otherwise just return the form for dashboard view
        contactForm
    );
}

ContactForm.propTypes = {
    user: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
};
